import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthHandler } from '../auth/auth.handler';
import { Env } from '@usimweb/core/models';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(@Inject('environment') private environment: Env, private authHandler: AuthHandler) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.environment.deployment !== 'appstore') {
      return next.handle(request).pipe(
        catchError((err) => {
          if (err.status === 401 || err.status === 403) {
            // auto logout if 401 response returned from api
            console.log('error');
            this.handleError(err);
          }

          if (request.url.includes('pptx')) {
            request = request.clone({ responseType: 'arraybuffer' });
            return next.handle(request);
          }

          const error = err.error.message || err.statusText;
          console.log('Some error message');
          console.log(err);
          return throwError(error);
        })
      );
    } else {
      // if deployment is appstore
      return next.handle(request);
    }
  }

  // only for ultrasimweb deployment
  handleError(error: Response) {
    if (this.authHandler.isTokenExpired) {
      console.log('calls auth endpoint');
      return this.authHandler.authenticate;
    } else if (error.status === 403) {
      console.log('You are not authorized, "fallback" page will be shown');
    }
  }
}
